import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=01e6577a"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=01e6577a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports